export const speed = {
  fast: 100,
  medium: 250,
  slow: 500
};